import { Users, BedDouble, Bath, Home, Ruler } from "lucide-react";
import { useLang, useSiteSettings } from "@/context/LanguageContext";
import { useAmenityCatalog } from "@/lib/amenityCatalog";
import { resolveFacts } from "@/lib/propertyFacts";
import { amenityIcon } from "@/components/AmenityList";
import { tr } from "@/lib/translations";

/** Kurzinfos eines Objekts (Reihenfolge/Sichtbarkeit aus Einstellungen → Kurzinfos). limit 0 = alle; iconOnly für Kacheln. */
export const PropertyFacts = ({ property: p, limit = 0, iconOnly = false, className = "", testId = "property-facts" }) => {
  const { t, lang } = useLang();
  const site = useSiteSettings();
  const cat = useAmenityCatalog();
  const facts = resolveFacts(site.property_facts, cat?.items || []).filter((f) => f.on && f.key !== "weather");
  const has = (de) => (p.amenities || []).some((a) => a.replace(/\s*\([^)]*\)\s*$/, "") === de);
  // Kurzinfo-Merkmal gilt auch über seine Aliase (z. B. WLAN → Internetzugang, Privatpool → Pool)
  const matchAmenity = (am) => [am, ...(cat?.items || []).filter((x) => am.filter_key && x.alias_of === am.filter_key)].find((x) => has(x.label.de));
  const base = {
    guests: { Icon: Users, value: p.max_guests, label: t.property.guests },
    bedrooms: p.bedrooms > 0 && { Icon: BedDouble, value: p.bedrooms, label: t.wishlist.bedrooms },
    bathrooms: { Icon: Bath, value: p.bathrooms, label: t.wishlist.bathrooms },
    size: p.size_sqm > 0 && { Icon: Ruler, value: `${p.size_sqm} m²`, label: "" },
    type: t.filters?.[p.type] && { Icon: Home, value: "", label: t.filters[p.type] },
  };
  const items = facts.map((f) => {
    if (f.amenity) { const m = matchAmenity(f.amenity); return m ? { key: f.key, Icon: amenityIcon(m.label.de), value: "", label: tr(m.label, lang) } : null; }
    const b = base[f.key];
    return b ? { key: f.key, ...b } : null;
  }).filter(Boolean);
  const n = Number(limit) || 0;
  const shown = n > 0 ? items.slice(0, n) : items;
  if (!shown.length) return null;
  const size = iconOnly ? "w-4 h-4" : "w-4 h-4";
  return (
    <div className={`flex flex-wrap items-center ${iconOnly ? "gap-x-3 gap-y-1" : "gap-x-6 gap-y-2.5"} ${className}`} data-testid={testId}>
      {shown.map(({ key, Icon, value, label }) => (
        <span key={key} className="flex items-center gap-1.5" title={[value, label].filter(Boolean).join(" ")} data-testid={`${testId}-${key}`}>
          <Icon className={`${size} text-brand`} />
          {iconOnly ? (value !== "" && value !== undefined && value !== null ? <span>{value}</span> : null) : <>{value !== "" ? `${value} ` : ""}{label}</>}
        </span>
      ))}
    </div>
  );
};
